module.exports = __webpack_public_path__ + "static/img/L.60a76d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/L.png
// module id = 1pYs
// module chunks = 1